<template>
  <div class="login-page">
    <!-- 动态背景层 -->
    <div class="login-bg">
      <div class="bg-gradient"></div>
      <div class="bg-pattern"></div>
      <div class="bg-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>

    <!-- 左侧品牌展示区 -->
    <div class="brand-section">
      <div class="brand-content">
        <div class="brand-logo">
          <div class="logo-icon">
            <i class="el-icon-office-building"></i>
          </div>
        </div>
        <h1 class="brand-title">邻通社区物管平台</h1>
        <p class="brand-desc">数字化赋能，让社区管理更智能、更高效、更贴心</p>
        <div class="brand-features">
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-s-home"></i>
            </div>
            <div class="feature-info">
              <span class="feature-title">智能社区</span>
              <span class="feature-desc">全方位社区服务管理</span>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-s-order"></i>
            </div>
            <div class="feature-info">
              <span class="feature-title">工单管理</span>
              <span class="feature-desc">高效处理业主需求</span>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-s-data"></i>
            </div>
            <div class="feature-info">
              <span class="feature-title">数据洞察</span>
              <span class="feature-desc">实时数据分析报表</span>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-s-platform"></i>
            </div>
            <div class="feature-info">
              <span class="feature-title">移动办公</span>
              <span class="feature-desc">随时随地处理事务</span>
            </div>
          </div>
        </div>
      </div>
      <div class="brand-footer">
        <p class="copyright">&copy; 2019-2026 小通物业 版权所有</p>
      </div>
    </div>

    <!-- 右侧登录表单区 -->
    <div class="login-section">
      <div class="login-card fade-in">
        <div class="login-header">
          <h2 class="login-title">欢迎登录</h2>
          <p class="login-subtitle">请使用您的账号密码登录系统</p>
        </div>

        <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form" @keyup.enter.native="submitForm('loginForm')">
          <div class="form-group">
            <el-form-item prop="username">
              <div class="input-wrapper">
                <i class="el-icon-user input-icon"></i>
                <el-input
                  v-model="loginForm.username"
                  :placeholder="$t('login.usernamePlaceholder')"
                  class="form-input"
                  prefix-icon="none"
                ></el-input>
              </div>
            </el-form-item>
          </div>

          <div class="form-group">
            <el-form-item prop="passwd">
              <div class="input-wrapper">
                <i class="el-icon-lock input-icon"></i>
                <el-input
                  v-model="loginForm.passwd"
                  type="password"
                  :placeholder="$t('login.passwordPlaceholder')"
                  class="form-input"
                  prefix-icon="none"
                  show-password
                ></el-input>
              </div>
            </el-form-item>
          </div>

          <div class="form-group">
            <el-form-item prop="validateCode">
              <div class="captcha-row">
                <div class="input-wrapper captcha-input">
                  <i class="el-icon-key input-icon"></i>
                  <el-input
                    v-model="loginForm.validateCode"
                    :placeholder="$t('login.captchaPlaceholder')"
                    class="form-input"
                    prefix-icon="none"
                  ></el-input>
                </div>
                <img
                  :src="captchaUrl"
                  @click="refreshCaptcha"
                  class="captcha-img"
                  alt="验证码"
                  title="点击刷新验证码"
                />
              </div>
            </el-form-item>
          </div>

          <div class="form-options">
            <el-checkbox v-model="rememberMe" class="remember-checkbox">记住账号</el-checkbox>
            <a href="javascript:void(0)" class="forgot-link" @click="handleForgot">忘记密码？</a>
          </div>

          <div class="form-group">
            <el-button
              type="primary"
              @click="submitForm('loginForm')"
              :loading="loading"
              class="login-btn"
            >
              {{ $t('login.login') }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 多账号选择弹窗 -->
    <select-login-user ref="selectLoginUserRef" @select="handleSelect"></select-login-user>

    <!-- 忘记密码弹窗 -->
    <el-dialog
      title="忘记密码"
      :visible.sync="forgotDialogVisible"
      width="400px"
      custom-class="forgot-dialog"
      :close-on-click-modal="false"
    >
      <div class="forgot-content">
        <i class="el-icon-warning forgot-icon"></i>
        <p class="forgot-text">请联系系统管理员重置密码</p>
        <p class="forgot-contact">技术支持：400-888-8888</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { login, getCaptcha, _loadStaffPrivileges } from '@/api/user/loginApi';
import { _loadCommunityInfo } from '@/api/community/communityApi';
import { listSystemInfo } from '@/api/system/systemInfoManageApi';
import selectLoginUser from '@/components/user/selectLoginUser.vue';

export default {
  name: 'Login',
  data() {
    return {
      companyName: '',
      rememberMe: false,
      forgotDialogVisible: false,
      loginForm: {
        username: '',
        passwd: '',
        validateCode: ''
      },
      captchaUrl: '',
      loading: false,
      rules: {
        username: [
          { required: true, message: this.$t('login.usernamePlaceholder'), trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: this.$t('login.passwordPlaceholder'), trigger: 'blur' }
        ],
        validateCode: [
          { required: true, message: this.$t('login.captchaPlaceholder'), trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    // SSO 免密登录：检测 URL 中的 hcAccessToken
    const href = window.location.href
    const ssoMatch = href.match(/hcAccessToken=([^&]+)/)
    if (ssoMatch) {
      const ssoParams = new URLSearchParams(href.split('?').pop())
      const ssoToken = ssoParams.get('hcAccessToken')
      const ssoUserId = ssoParams.get('userId') || ''
      const ssoUserName = ssoParams.get('userName') || '物业用户'
      const ssoTel = ssoParams.get('tel') || ''
      const ssoCommunityId = ssoParams.get('communityId') || ''
      this.handleSelect({
        token: ssoToken,
        userId: ssoUserId,
        name: ssoUserName,
        tel: ssoTel,
        communityId: ssoCommunityId
      })
      return
    }
    localStorage.clear();
    this.getSystemInfo();
    this.loadRememberedUser();
    setTimeout(() => {
      this.refreshCaptcha();
    }, 1000);
  },
  components: {
    selectLoginUser
  },
  methods: {
    async getSystemInfo() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 });
        if (data && data.length > 0) {
          this.companyName = data[0].companyName;
        }
      } catch (error) {
        console.error('获取系统信息失败：', error);
      }
    },
    loadRememberedUser() {
      const remembered = localStorage.getItem('remembered_username');
      if (remembered) {
        this.loginForm.username = remembered;
        this.rememberMe = true;
      }
    },
    saveRememberedUser() {
      if (this.rememberMe) {
        localStorage.setItem('remembered_username', this.loginForm.username);
      } else {
        localStorage.removeItem('remembered_username');
      }
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const { data } = await login(this.loginForm).catch(error => {
              this.$message.error(error);
              this.refreshCaptcha();
              return { data: [] };
            });
            if (!data || data.length == 0) {
              return;
            }

            this.saveRememberedUser();

            if (data && data.length > 1) {
              this.$refs.selectLoginUserRef.openDialog(data);
              return;
            }
            this.handleSelect(data[0]);
          } catch (error) {
            console.error('登录失败：', error);
            this.refreshCaptcha();
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
    async handleSelect(_userData) {
      localStorage.setItem('token', _userData.token);
      let _user = {
        userId: _userData.userId,
        name: _userData.name,
        tel: _userData.tel
      }
      localStorage.setItem('user', JSON.stringify(_user));
      localStorage.removeItem('hc_currentCommunityInfo');
      localStorage.removeItem('hc_communityInfo');
      localStorage.removeItem('hc_staff_privilege');
      await _loadStaffPrivileges();
      await _loadCommunityInfo({ communityId: _userData.communityId || '' });
      this.$router.push('/');
    },
    async refreshCaptcha() {
      try {
        const res = await getCaptcha();
        this.captchaUrl = res;
      } catch (error) {
        console.error('获取验证码失败：', error);
        this.$message.error(this.$t('login.getCaptchaFailed'));
      }
    },
    handleForgot() {
      this.forgotDialogVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
// ========== 变量定义 ==========
$primary: #2B7FF0;
$primary-light: #4A9FFF;
$primary-dark: #1A6FDF;
$primary-gradient: linear-gradient(135deg, #2B7FF0 0%, #4A9FFF 50%, #6BB3FF 100%);
$text-primary: #1F2329;
$text-secondary: #646A73;
$text-tertiary: #8F959E;
$bg-page: #F5F6F8;
$bg-card: #FFFFFF;
$border-light: #F2F3F5;
$border-base: #E5E6EB;
$shadow-card: 0 8px 32px rgba(0, 0, 0, 0.08);
$shadow-hover: 0 12px 48px rgba(43, 127, 240, 0.15);

// ========== 页面布局 ==========
.login-page {
  min-height: 100vh;
  display: flex;
  position: relative;
  overflow: hidden;
  background: $bg-page;
}

// ========== 动态背景 ==========
.login-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;

  .bg-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #0F172A 0%, #1E3A5F 40%, #1E40AF 100%);
  }

  .bg-pattern {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      radial-gradient(circle at 20% 50%, rgba(255,255,255,0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(255,255,255,0.03) 0%, transparent 50%);
  }

  .bg-shapes {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;

    .shape {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.04);
      animation: float 8s ease-in-out infinite;

      &.shape-1 {
        width: 500px;
        height: 500px;
        top: -150px;
        right: -150px;
      }

      &.shape-2 {
        width: 350px;
        height: 350px;
        bottom: -80px;
        left: -80px;
        animation-delay: 2s;
      }

      &.shape-3 {
        width: 250px;
        height: 250px;
        top: 40%;
        left: 30%;
        animation-delay: 4s;
      }
    }
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-30px) scale(1.05);
    opacity: 0.6;
  }
}

// ========== 左侧品牌区 ==========
.brand-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 60px 80px;
  position: relative;
  z-index: 1;
  color: #fff;
  min-height: 100vh;

  .brand-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 520px;
  }

  .brand-logo {
    margin-bottom: 32px;

    .logo-icon {
      width: 72px;
      height: 72px;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(255, 255, 255, 0.2);

      i {
        font-size: 36px;
        color: #fff;
      }
    }
  }

  .brand-title {
    font-size: 38px;
    font-weight: 700;
    margin: 0 0 12px 0;
    line-height: 1.2;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  .brand-desc {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 40px 0;
    line-height: 1.6;
  }

  .brand-features {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    .feature-item {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 16px;
      background: rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(10px);
      border-radius: 14px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.08);
      }

      .feature-icon {
        width: 44px;
        height: 44px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        i {
          font-size: 22px;
          color: #fff;
        }
      }

      .feature-info {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .feature-title {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
        }

        .feature-desc {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }

  .brand-footer {
    margin-top: 40px;

    .copyright {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      margin: 0;
    }
  }
}

// ========== 右侧登录区 ==========
.login-section {
  width: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  z-index: 1;

  .login-card {
    width: 100%;
    background: $bg-card;
    border-radius: 20px;
    padding: 44px 36px;
    box-shadow: $shadow-card;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: $shadow-hover;
    }
  }

  .login-header {
    text-align: center;
    margin-bottom: 28px;

    .login-title {
      font-size: 26px;
      font-weight: 700;
      color: $text-primary;
      margin: 0 0 6px 0;
    }

    .login-subtitle {
      font-size: 13px;
      color: $text-tertiary;
      margin: 0;
    }
  }

  .login-form {
    margin-bottom: 0;
  }

  .form-group {
    margin-bottom: 18px;
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    background: #F7F8FA;
    border-radius: 10px;
    padding: 0 14px;
    height: 44px;
    border: 2px solid transparent;
    transition: all 0.2s ease;

    &:focus-within {
      border-color: $primary-light;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }

  .input-icon {
    font-size: 16px;
    color: $text-tertiary;
    margin-right: 10px;
    transition: color 0.2s ease;
    flex-shrink: 0;
  }

  .input-wrapper:focus-within .input-icon {
    color: $primary;
  }

  .form-input {
    flex: 1;

    ::v-deep .el-input__inner {
      background: transparent;
      border: none;
      padding: 0;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: $text-primary;

      &::placeholder {
        color: #BBBFC4;
      }

      &:focus {
        outline: none;
      }
    }
  }

  .captcha-row {
    display: flex;
    gap: 10px;
    align-items: center;

    .captcha-input {
      flex: 1;
    }

    .captcha-img {
      width: 110px;
      height: 44px;
      border-radius: 8px;
      cursor: pointer;
      object-fit: cover;
      border: 2px solid $border-light;
      transition: all 0.2s ease;
      flex-shrink: 0;

      &:hover {
        border-color: $primary-light;
      }
    }
  }

  .form-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .remember-checkbox {
      ::v-deep .el-checkbox__label {
        font-size: 13px;
        color: $text-secondary;
      }

      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: $primary;
        border-color: $primary;
      }
    }

    .forgot-link {
      font-size: 13px;
      color: $primary;
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: $primary-dark;
        text-decoration: underline;
      }
    }
  }

  .login-btn {
    width: 100%;
    height: 44px;
    background: $primary-gradient;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(43, 127, 240, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// ========== 动画 ==========
.fade-in {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// ========== 忘记密码弹窗 ==========
.forgot-dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid $border-light;
    padding: 20px 24px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: $text-primary;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 32px 24px;
  }
}

.forgot-content {
  text-align: center;

  .forgot-icon {
    font-size: 48px;
    color: $primary;
    margin-bottom: 16px;
  }

  .forgot-text {
    font-size: 16px;
    color: $text-primary;
    margin: 0 0 8px 0;
  }

  .forgot-contact {
    font-size: 14px;
    color: $text-tertiary;
    margin: 0;
  }
}

// ========== 响应式设计 ==========
@media screen and (max-width: 1024px) {
  .brand-section {
    padding: 40px;

    .brand-title {
      font-size: 32px;
    }

    .brand-features {
      grid-template-columns: 1fr;
    }
  }

  .login-section {
    width: 420px;
    padding: 30px;
  }
}

@media screen and (max-width: 768px) {
  .login-page {
    flex-direction: column;
  }

  .login-bg {
    .bg-shapes {
      display: none;
    }
  }

  .brand-section {
    min-height: auto;
    padding: 30px 24px;
    text-align: center;

    .brand-content {
      align-items: center;
    }

    .brand-logo {
      .logo-icon {
        margin: 0 auto;
      }
    }

    .brand-features {
      display: none;
    }

    .brand-footer {
      display: none;
    }
  }

  .login-section {
    width: 100%;
    padding: 0 20px 30px;

    .login-card {
      padding: 28px 20px;
    }
  }
}
</style>
